import React from 'react';
import './AboutUs.css';


function AboutUs() {
  return (
    <div className='About'>
  <div class="banner-container">
  <h2 class="banner-title">À Propos de Nous
  <h5 class="banner-subtitle">Service nettoyage <span className='greater'>&gt;</span> À propos</h5></h2>
    <div class="banner-slider">
    <div class="banner-slide"><img src="vt.jpg" alt="Image 1" loading="lazy"/></div>
    <div class="banner-slide"><img src="tem.jpg" alt="Image 2" loading="lazy"/></div>
    <div class="banner-slide"><img src="restau.jpg" alt="Image 3 "loading="lazy"/></div>
  </div>
</div>

<div class="about-us-container">
  <div class="tect-container">
    <h2><img src="abss.png" alt="Appeler" class="phon-icon"loading="lazy" />Chez Nous, le travail d'équipe est au cœur de toutes nos actions.</h2>
    <p>
        <span class='pe1'>Bio cleaners services</span> est une entreprise de nettoyage écologique située à Agadir et opérant également à Casablanca et Marrakech. Nous sommes spécialisés dans le nettoyage résidentiel, commercial et industriel et proposons une gamme complète de services de nettoyage adaptés aux besoins de chaque client. Notre équipe d'experts est formée pour offrir des services de nettoyage de haute qualité, centrés sur la satisfaction client et le respect de l'environnement.
Chez <span class='pe1'>Bio cleaners ,</span> nous utilisons des méthodes et des produits de nettoyage innovants et écologiques pour assurer un espace propre, sain et accueillant à chaque intervention. Nous croyons en l'importance de la collaboration et de la synergie pour atteindre l'excellence. Notre mission est de créer des environnements propres et durables, et le respect de l'environnement n’est pas seulement une option, mais un engagement.
    </p>  
</div>

  <div class="imge-container">
    <div class="image-wrapper">
      <img src="smal.jpg" alt="Biocleaners" class="main-image"loading="lazy" />
      <div class="smll-images">
        <img src="canapé.jpg" alt="Image centre" class="smal-image center"loading="lazy" />
        <img src="small2.jpg" alt="Image droite" class="smal-image right" loading="lazy"/>
      </div>
    </div>
  </div>
</div>


<div class="cointainer">
  <div class="lef-section">
    <h2><img src="ballet.png" alt="Appeler" class="phon-icon" loading="lazy"/>POURQUOI NOUS CHOISIR ?</h2>
    <h1>Entreprise de nettoyage la plus récompensée au Maroc.</h1>
  </div>
  <div class="righ-section">
    <p>Chez Biocleaners, nous sommes engagés à offrir un service de nettoyage professionnel et de haute qualité pour les résidences et entreprises à Agadir, Casablanca, et Marrakech. Nous sélectionnons rigoureusement notre personnel qualifié, afin de garantir une intervention efficace, sécurisée et respectueuse de vos espaces.</p>
    <p>En choisissant Biocleaners, vous optez pour des prestations sur mesure , des produits écologiques, une expertise de confiance . Faites confiance à Biocleaners pour un nettoyage irréprochable et une satisfaction garantie.</p>
    <div class="call-to-action">
    <div class="call-us-container">
  <div class="call-icon-text">
    <img src="phone.png" alt="Appeler" class="phon-icon" loading="lazy"/>
    <span class="call-text">APPELEZ-NOUS</span>
  </div>
  <a href="tel:+212622309354" class="call-number">+212 6 55 76 00 51</a>
</div>

  <a href="/Book" class="book-demo">
    Réservez un devis gratuit <i class="fas fa-arrow-right"></i>
  </a>
</div>
</div>
</div>

<div className='title'>
<div className='div2'><h3 ><span className='bio'>Bio Cleaners </span> <span className='span2'>SERVICES</span></h3></div>
    <h2> <img src="/freakels.png" className='frs'loading="lazy" />Les Avantages de Bio Cleaners services</h2>
    </div>
<div class="containert">
    <div class="cardo">
        <div class="cardo-content">
            <h2>Efficacité</h2>
            <p>En travaillant comme une unité cohésive, nous rationalisons nos processus pour garantir une efficacité optimale dans nos opérations. 
Cette efficacité se traduit par des délais d'exécution plus rapides et des résultats de haute qualité pour nos précieux clients.
</p>
        </div>
        <img src="/efficace.jpg" alt="Image 1" loading="lazy"/>
    </div>
    <div class="cardo">
        <div class="cardo-content">
            <h2>Expertise</h2>
            <p>Chaque membre de notre équipe apporte ses compétences et son expérience uniques. En combinant nos connaissances, nous sommes en mesure de relever même les tâches de nettoyage les plus difficiles avec confiance et précision.
            </p>
        </div>
        <img src="/equipe.avif" alt="Image 2" loading="lazy"/>
    </div>
    <div class="cardo">
        <div class="cardo-content">
            <h2>Innovation</h2>
            <p>Encourager le travail d'équipe favorise également un environnement propice à l'innovation. Nous brainstormons constamment et échangeons des idées pour améliorer nos méthodes et rester à la pointe des tendances de l'industrie</p>
        </div>
        <img src="/team.jpg" alt="Image 3" loading="lazy"/>
          
    </div>
    <div class="cardo">
        <div class="cardo-content">
            <h2>Focus sur le Client</h2>
            <p>Nos clients sont au centre de nos préoccupations. Grâce à une collaboration efficace, nous sommes mieux à même de comprendre leurs besoins et de fournir des solutions sur mesure qui dépassent leurs attentes. 
            </p>
        </div>
        <img src="/focus1.jpg" alt="Image 4" loading="lazy"/>
    </div>
    <div class="cardo">
        <div class="cardo-content">
            <h2>Moral et Motivation</h2>
            <p>Un fort esprit d'équipe stimule le moral et la motivation de chaque membre. Nous nous soutenons mutuellement, célébrons nos réussites ensemble et surmontons les défis en tant qu'équipe soudée.</p>
        </div>
        <img src="/motivation.jpg" alt="Image 5" loading="lazy"/>
    </div>
    <div class="cardo">
        <div class="cardo-content">
            <h2>Croissance Continue  </h2>
            <p>En tant qu'équipe, nous apprenons et évoluons en permanence. Des sessions régulières de formation et de développement de compétences garantissent que nos services restent à la pointe de l'industrie du nettoyage.
            </p>
        </div>
        <img src="/croissance.jpg" alt="Image 6" loading="lazy"/>
    </div>
</div>
<div className="banne">
      <div className="text-section">
        <h1>Travaillons ensemble <br />pour <span className='bannes'>un avenir <br />plus propre et plus sain !</span></h1>
      </div>
      <div className="button-section">
        <a href="/Book" className="reserva-button">
          <span>Réserver maintenant</span>
        </a>
        <a href="/Contact" className="reserva1-button"> 
          <span>Contactez-Nous</span>
        </a>
      </div>
    </div>
   
    <div class="amazing-evolution">
    <h1>Évolution Impressionnante de Votre Espace</h1>
    <div class="evolution-items">
    <div class="item">
      <img src="clean.png" alt="Icon 1" loading="lazy"/>
      <h3>Espaces Propres et Organisés</h3>
      <p>Nettoyage complet pour des espaces sains, ordonnés et accueillants.</p>
    </div>
    <div class="item">
      <img src="eco.png" alt="Icon 2" loading="lazy"/>
      <h3>Produits Non-Toxiques et Écologiques</h3>
      <p>Solutions de nettoyage sûres, respectueuses de l’environnement et de la santé.</p>
    </div>
    <div class="item">
      <img src="service.png" alt="Icon 3" loading="lazy"/>
      <h3>Personnel Qualifié et de Confiance</h3>
      <p>Une équipe de nettoyage formée pour des services fiables et de haute qualité.</p>
    </div>
    <div class="item">
      <img src="deadline.png" alt="Icon 4" loading="lazy"/>
      <h3>Service Flexible et Personnalisé</h3>
      <p>Des options de réservation et des horaires adaptés à vos besoins spécifiques.</p>
    </div>
  </div>
</div>
<section class="comment-ca-marche">
  <h4>COMMENT CA MARCHE</h4>
  <h1>Un moyen simple d'obtenir des services</h1>
  <div class="etapes">
    <div class="etape">
      <h2>ÉTAPE 1</h2>
      <h3>Choisissez le service souhaité</h3>
      <p>Sélectionnez parmi nos forfaits celui qui correspond à vos besoins.</p>
    </div>
    <div class="etape">
      <h2>ÉTAPE 2</h2>
      <h3>Joignez-nous rapidement</h3>
      <p>Cliquez sur "Contactez-nous" pour discuter de vos besoins.</p>
    </div>
    <div class="etape">
      <h2>ÉTAPE 3</h2>
      <h3>Réservez votre service</h3>
      <p>Profitez d'un nettoyage rapide et de qualité.</p>
    </div>
    <div class="etape finale">
      <h2>ÉTAPE FINALE</h2>
      <h3>Profitez de nos services</h3>
      <p>Détendez-vous pendant que nous donnons vie à votre vision.</p>
    </div>
  </div>
  <div className='bcm'>
  <a href="/Contact" class="btns">Contactez-nous</a>
  </div>
</section>

    <div className="containeir">
      <div className="image-section">
        <img src="/time.png" alt="Description"loading="lazy" />
      </div>
      <div className="texts-section">
        <h1>Horaires</h1>
        <p className='P1'>Les heures de travail de Bio Cleaners Services sont conçues pour répondre aux besoins de nos clients de manière flexible et pratique.</p>
        <h3>Voici nos horaires typiques de travail :</h3>
        <p className='P2'>Du lundi au vendredi : de 08h00 à 18h00<br />
           Samedi : de 09h00 à 14h00</p>
        <div className="note">
          <p>Cependant, nous comprenons que chaque client a des exigences différentes en matière d'horaires de nettoyage. Nous sommes ouverts à discuter des arrangements spéciaux pour les clients ayant des besoins particuliers en matière d'heures de travail. Que vous ayez besoin d'un nettoyage tôt le matin, en soirée ou même pendant le week-end, notre équipe fera de son mieux pour s'adapter à votre emploi du temps.</p>
        </div>
      </div>
    </div>
   
    </div>
  
  );
}

export default AboutUs;
